import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import module from 'app/modules/daily-activity-tracker/daily-activity-tracker.module';

@Component({
  selector: 'app-complete-form',
  standalone: true,
  imports: module,
  templateUrl: './complete-form.component.html',
  styleUrl: './complete-form.component.scss'
})
export class CompleteFormComponent {
  form: FormGroup;
  today = new Date();

  constructor(
    public dialogRef: MatDialogRef<CompleteFormComponent>,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      completedDate: new FormControl({ value: new Date(), disabled: false })
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.form.get('completedDate').value);
  }
}

